/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PharmacyBookmark, PharmacyBookmarkFromJSON, PharmacyBookmarkFromJSONTyped, PharmacyBookmarkToJSON } from "./";

export const PatchBookmarksRequestBodyTypename = "PatchBookmarksRequestBody" as const;

/**
 *
 * @export
 * @interface PatchBookmarksRequestBody
 */
export interface PatchBookmarksRequestBody {
  /**
   *
   * @type {Array<PharmacyBookmark>}
   * @memberof PatchBookmarksRequestBody
   */
  bookmarks?: Array<PharmacyBookmark>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatchBookmarksRequestBody
   */
  readonly __typename?: string;
}

export function PatchBookmarksRequestBodyFromJSON(json: any): PatchBookmarksRequestBody {
  return PatchBookmarksRequestBodyFromJSONTyped(json, false);
}

export function PatchBookmarksRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchBookmarksRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatchBookmarksRequestBodyTypename,

    bookmarks: !exists(json, "bookmarks") ? undefined : (json["bookmarks"] as Array<any>).map(PharmacyBookmarkFromJSON),
  };
}

export function PatchBookmarksRequestBodyToJSON(object?: PatchBookmarksRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    bookmarks: value.bookmarks === undefined ? undefined : (value.bookmarks as Array<any>).map(PharmacyBookmarkToJSON),
  };
}
